import { Box, DashboardModule, Form } from '@domain-group/suit-theme'

import { UseFormPayload } from '@domain-group/react-hooks'

import InfoToolTip from '@components/InfoToolTip'

interface PropertyAddressProps {
  campaignForm: UseFormPayload,
}

const PropertyFeatures = (props: PropertyAddressProps) => {
  const { campaignForm } = props

  const {
    entityState: {
      bathrooms,
      bedrooms,
      building_area,
      building_area_units,
      carparks,
      carports,
      car_spaces,
      dining_rooms,
      facilities,
      living_areas,
      studies,
      year_built,
    },
    handlers,
  } = campaignForm

  return (
    <DashboardModule title="Property Features">
      <Form padding="large">
        <Form.Row>
          <Form.Row>
            <Form.Field label="Bedrooms">
              <input
                name="bedrooms"
                type="text"
                value={bedrooms}
                {...handlers}
              />
            </Form.Field>

            {/*
             // @ts-expect-error TS2322 */}
            <Form.Field label="Bathrooms" marginTop={['large', 0]}>
              <input
                name="bathrooms"
                type="text"
                value={bathrooms}
                {...handlers}
              />
            </Form.Field>
          </Form.Row>

          <Form.Row>
            {/*
             // @ts-expect-error TS2322 */}
            <Form.Field label="Garages" marginTop={['large', 0]}>
              <input
                name="carparks"
                type="text"
                value={carparks}
                {...handlers}
              />
            </Form.Field>

            {/*
             // @ts-expect-error TS2322 */}
            <Form.Field label="Carports" marginTop={['large', 0]}>
              <input
                name="carports"
                type="text"
                value={carports}
                {...handlers}
              />
            </Form.Field>
          </Form.Row>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Row>
            <Form.Field
              // @ts-expect-error TS2322
              label={(
                <>
                  <Box marginRight="small">Car Spaces</Box>

                  <InfoToolTip>
                    Car spaces available on the property that are neither a garage or carport
                  </InfoToolTip>
                </>
            )}
            >
              <input
                name="car_spaces"
                type="text"
                value={car_spaces}
                {...handlers}
              />
            </Form.Field>

            {/*
             // @ts-expect-error TS2322 */}
            <Form.Field label="Living Areas" marginTop={['large', 0]}>
              <input
                name="living_areas"
                type="text"
                value={living_areas}
                {...handlers}
              />
            </Form.Field>
          </Form.Row>

          <Form.Row>
            {/*
             // @ts-expect-error TS2322 */}
            <Form.Field label="Studies" marginTop={['large', 0]}>
              <input
                name="studies"
                type="text"
                value={studies}
                {...handlers}
              />
            </Form.Field>

            {/*
             // @ts-expect-error TS2322 */}
            <Form.Field label="Dining Rooms" marginTop={['large', 0]}>
              <input
                name="dining_rooms"
                type="text"
                value={dining_rooms}
                {...handlers}
              />
            </Form.Field>
          </Form.Row>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Row>
            <Form.Field label="Building Area">
              <input
                name="building_area"
                type="text"
                value={building_area}
                {...handlers}
              />
            </Form.Field>

            {/*
             // @ts-expect-error TS2322 */}
            <Form.Field label="Area Units" marginTop={['large', 0]}>
              {/*
               // @ts-expect-error TS2322 */}
              <select name="building_area_units" value={building_area_units} {...handlers}>
                <option value="">Please Select...</option>
                <option value="squareMeter">Square Metres</option>
                <option value="square">Squares</option>
              </select>
            </Form.Field>
          </Form.Row>

          <Form.Row>
            {/*
             // @ts-expect-error TS2322 */}
            <Form.Field label="Year Built" marginTop={['large', 0]}>
              <input
                name="year_built"
                type="text"
                value={year_built}
                {...handlers}
              />
            </Form.Field>

            {/*
             // @ts-expect-error TS2322 */}
            <Form.Field label="Facilities" marginTop={['large', 0]}>
              {/*
               // @ts-expect-error TS2322 */}
              <select name="facilities" value={facilities} {...handlers}>
                <option value="">None</option>
                <option value="1">Pool</option>
                <option value="2">Tennis Court</option>
                <option value="3">Pool &amp; Tennis Court</option>
              </select>
            </Form.Field>
          </Form.Row>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

export default PropertyFeatures
